/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DnspForProject
 */
export interface DnspForProject {
    /**
     *
     * @type {string}
     * @memberof DnspForProject
     */
    project?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof DnspForProject
     */
    dnsps?: Array<string>;
}

/**
 * Check if a given object implements the DnspForProject interface.
 */
export function instanceOfDnspForProject(
    value: object,
): value is DnspForProject {
    return true;
}

export function DnspForProjectFromJSON(json: any): DnspForProject {
    return DnspForProjectFromJSONTyped(json, false);
}

export function DnspForProjectFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DnspForProject {
    if (json == null) {
        return json;
    }
    return {
        project: json["project"] == null ? undefined : json["project"],
        dnsps: json["dnsps"] == null ? undefined : json["dnsps"],
    };
}

export function DnspForProjectToJSON(value?: DnspForProject | null): any {
    if (value == null) {
        return value;
    }
    return {
        project: value["project"],
        dnsps: value["dnsps"],
    };
}
